import BiwengerIcon from './biwenger-icon';
import FantasyLaLigaIcon from './fantasy-la-liga-icon';
import FantasyMarcaIcon from './FantasyMarcaIcon';
import MisterFantasyIcon from './MisterFantasyIcon';
import AnaliticaFantasyIcon from './analitica-fantasy-icon';
import { FANTASY } from '@/helpers/biwenger-helper';

const FantasyIconSelector = ({ fantasy, size = 20, style }) => {
    const iconSize = size;

    switch (fantasy) {
        case FANTASY.BIWENGER:
            return <BiwengerIcon width={iconSize} height={iconSize} style={style} />;
        case FANTASY.FANTASY:
            return <FantasyLaLigaIcon iconWidth={iconSize} iconHeight={iconSize} style={style} />;
        case FANTASY.FANTASY_MARCA:
            return <FantasyMarcaIcon width={iconSize} height={iconSize} style={style} />;
        case FANTASY.MISTER_FANTASY:
            return <MisterFantasyIcon width={iconSize} height={iconSize} style={style} />;
        case FANTASY.ANALITICA:
            return <AnaliticaFantasyIcon width={iconSize} style={style} />;
        default:
            return <AnaliticaFantasyIcon width={iconSize} style={style} />;
    }
};

export default FantasyIconSelector;
